import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select'
import './LanguageSelector.scss'

export interface LanguageSelectorProps {
  /** Stretch the trigger to the container width (e.g. the Account nav footer).
   *  Defaults to the fixed 140px width used elsewhere. */
  fullWidth?: boolean
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ fullWidth = false }) => {
  const { i18n } = useTranslation()

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' }
  ]

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value)
  }

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0]

  return (
    <Select value={i18n.language} onValueChange={handleLanguageChange}>
      <SelectTrigger className={`${fullWidth ? 'w-full' : 'w-[140px]'} h-8 text-xs bg-background border-input`}>
        <SelectValue>
          {currentLanguage.name}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            {lang.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export default LanguageSelector